export const VIEW_NOTE = 'view-note'
